// Estado de receptora. Valores del contrato (admin-recipients.md): 2 = activa
// (default, ≠0), 0 = soft-delete/tombstone; 1 reservado a inactiva. El canal
// público normalmente no devuelve status=0. Etiqueta en femenino ("receptora").
const STATUS_LABEL = {
    2: 'Activa',
    1: 'Inactiva',
    0: 'Eliminada',
};

export function statusLabel(status) {
    return STATUS_LABEL[status] ?? 'Desconocido';
}

// Clase BEM modificadora para el badge de estado (styles/overview.css).
export function statusModifier(status) {
    return `parcerias-card__status--${status}`;
}
